<div class="extraInformationForm__cont">
  <ng-container *ngFor="let question of info?.Questions; first as isFirst; trackBy: trackById">
    <div class="extraInformationForm__input" [class.first]="isFirst">
      <ng-container [ngSwitch]="question.DataType">
        <ng-container *ngSwitchCase="extraQuestionDataType.Text">
          <div class="extraInformationForm__input-title">
            <app-ds-typography
              [text]="question.QuestionText"
              [size]="fontSize.XXS"
              [fontFamily]="fontFamily.SemiBold"
              [color]="fontColor.Primary"
              [tag]="'h3'">
            </app-ds-typography>
          </div>
          <app-form-text-input
            [id]="question.FormKey"
            [form]="dynamicForm"
            [hiddenPlaceholder]="true"
            [placeholder]="''"
            [formInputType]="formInputType.FULL_TEXT"
            [isSubmitted]="isSubmitted"
            [formControlSelector]="question.FormKey">
          </app-form-text-input>
        </ng-container>
        <ng-container *ngSwitchCase="extraQuestionDataType.Numeric">
          <div class="extraInformationForm__input-title">
            <app-ds-typography
              [text]="question.QuestionText"
              [size]="fontSize.XXS"
              [fontFamily]="fontFamily.SemiBold"
              [color]="fontColor.Primary"
              [tag]="'h3'">
            </app-ds-typography>
          </div>
          <app-form-text-input
            [id]="question.FormKey"
            [form]="dynamicForm"
            [hiddenPlaceholder]="true"
            [placeholder]="''"
            [formInputType]="formInputType.CUSTOM_MASK"
            [customMask]="inputMask.DIGITS"
            [isSubmitted]="isSubmitted"
            [formControlSelector]="question.FormKey">
          </app-form-text-input>
        </ng-container>
        <ng-container *ngSwitchCase="extraQuestionDataType.Date">
          <app-input-date
            [form]="dynamicForm"
            [label]="question.QuestionText"
            [isSubmitted]="isSubmitted"
            [invalidDate]="questionHasError(question.FormKey)"
            [dobSelector]="question.FormKey"
            [isNotABirthday]="true">
          </app-input-date>
        </ng-container>
        <ng-container *ngSwitchCase="extraQuestionDataType.TrueFalse">
          <app-ds-checkbox
            [title]="{ Label: question.QuestionText }"
            [failedType]="checkboxFailedType"
            [isFailed]="questionHasError(question.FormKey)"
            [checked]="checkboxIsChecked(question.FormKey)"
            (checkboxOnChecked)="checkboxCheckValue(question.FormKey, $event)">
          </app-ds-checkbox>
        </ng-container>
        <ng-container *ngSwitchCase="extraQuestionDataType.OptionList">
          <div class="extraInformationForm__input-title">
            <app-ds-typography
              [text]="question.QuestionText"
              [size]="fontSize.XXS"
              [fontFamily]="fontFamily.SemiBold"
              [color]="fontColor.Primary"
              [tag]="'h3'">
            </app-ds-typography>
          </div>
          <app-dropdown-select
            [fullWidth]="true"
            [selectOptions]="dropDownValues(question.QuestionOptionList)"
            [title]="question.QuestionText"
            [showError]="questionHasError(question.FormKey)"
            [withSearchInput]="dropdownIsScrollable(question.QuestionOptionList)"
            [scrollFixedPosition]="false"
            [manipulateDOM]="false"
            [isMobile]="isMobile"
            [fullHeight]="dropdownIsScrollable(question.QuestionOptionList)"
            (selected)="dropdownSelected(question.FormKey, $event)">
          </app-dropdown-select>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>
</div>